export const POI_TYPE = {
    POI: 0 /** 门店 */,
    DC: 1 /** 配送中心仓库 */, // 这个类型废弃掉了2018.6.22
    RDC: 2 /** RDC */,
    FDC: 3 /** 前置仓 */
};
